import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { API, Badge, Frist, dt, fehler, feld } from "./shared";

const LEER = { titel: "", massnahme: "", quelle: "", verantwortlich: "", frist: "", notiz: "" };

export const QMPunkte = () => {
  const [status, setStatus] = useState("offen");
  const [liste, setListe] = useState([]);
  const [neu, setNeu] = useState(LEER);
  const laden = useCallback(() => axios.get(`${API}/punkte?status=${status}`).then((r) => setListe(r.data)).catch(fehler), [status]);
  useEffect(() => { laden(); }, [laden]);
  const anlegen = async (e) => {
    e.preventDefault();
    await axios.post(`${API}/punkte`, neu).then(() => { toast.success("Punkt angelegt"); setNeu(LEER); laden(); }).catch(fehler);
  };
  const setze = (id, body) => axios.put(`${API}/punkte/${id}`, body).then(laden).catch(fehler);
  return (
    <div className="space-y-4" data-testid="qm-punkte">
      <form onSubmit={anlegen} className="grid grid-cols-2 md:grid-cols-6 gap-2 bg-white rounded-xl p-4 border border-[#F0E6DC]">
        <input className={`${feld} col-span-2`} placeholder="Offener Punkt *" required value={neu.titel} onChange={(e) => setNeu({ ...neu, titel: e.target.value })} data-testid="punkt-titel" />
        <input className={feld} placeholder="Maßnahme / Kurs" value={neu.massnahme} onChange={(e) => setNeu({ ...neu, massnahme: e.target.value })} data-testid="punkt-massnahme" />
        <input className={feld} placeholder="Verantwortlich *" required value={neu.verantwortlich} onChange={(e) => setNeu({ ...neu, verantwortlich: e.target.value })} data-testid="punkt-verantwortlich" />
        <input className={feld} type="date" required value={neu.frist} onChange={(e) => setNeu({ ...neu, frist: e.target.value })} data-testid="punkt-frist" />
        <Button type="submit" size="sm" className="bg-[#9A3B2E] hover:bg-[#7F2F25]" data-testid="punkt-anlegen">Anlegen</Button>
        <input className={`${feld} col-span-2 md:col-span-6`} placeholder="Quelle (z. B. Lückenliste Klassenbuch, internes Audit) und Notiz" value={neu.quelle} onChange={(e) => setNeu({ ...neu, quelle: e.target.value })} data-testid="punkt-quelle" />
      </form>
      <div className="flex items-center gap-2">
        {["offen", "erledigt", "alle"].map((s) => (
          <button key={s} onClick={() => setStatus(s)} className={`rounded-full px-3 py-1 text-xs ${status === s ? "bg-[#3D3835] text-white" : "bg-white border"}`} data-testid={`punkte-filter-${s}`}>{s}</button>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-[#F0E6DC] divide-y divide-[#F6E3DA]">
        {liste.length === 0 && <p className="p-4 text-sm text-[#8E7B71]" data-testid="punkte-leer">Keine Punkte.</p>}
        {liste.map((p) => (
          <div key={p.id} className="p-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`punkt-${p.id}`}>
            <span className="font-medium min-w-[220px]">{p.titel}</span>
            {p.massnahme && <Badge>{p.massnahme}</Badge>}
            <span className="text-[#78716c]">{p.verantwortlich}</span>
            <Frist frist={p.frist} erledigt={p.status === "erledigt"} />
            {p.quelle && <span className="text-xs text-[#8E7B71]">{p.quelle}</span>}
            <span className="ml-auto">
              {p.status === "offen"
                ? <Button size="sm" variant="outline" onClick={() => setze(p.id, { status: "erledigt" })} data-testid={`punkt-erledigt-${p.id}`}>Erledigt</Button>
                : <span className="text-xs text-[#4F6650]">erledigt {dt(p.erledigt_am)} ({p.erledigt_von})</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
